import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=35b1f756&scoped=true"
import script from "./ContractList.vue?vue&type=script&lang=js"
export * from "./ContractList.vue?vue&type=script&lang=js"
import style0 from "./ContractList.vue?vue&type=style&index=0&id=35b1f756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1f756",
  null
  
)

export default component.exports